export default "__VITE_ASSET__B0St68gd__"